import React, { useState } from "react";
import { Layout } from "antd";
import Sidenav from "./Sidebar";
import Header from "./Header";
const MainContent = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  return (
    <Layout className="min-h-screen">
      <Sidenav mobileOpen={mobileOpen} onMobileClose={handleDrawerClose} />
      <Layout className="flex-1 ml-0 xl:ml-60 transition-all duration-300">
        <Header onMenuClick={handleDrawerToggle} />
        <div className="flex-1 overflow-auto px-2 pt-6 pb-0 md:px-3 lg:px-4">
          {children}
        </div>
      </Layout>
    </Layout>
  );
};

export default MainContent;
